import { ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { DesktopFooter } from './desktop/desktop-footer';
import { MobileFooter } from './mobile/mobile-footer';

export const Footer = (): ReactElement => {
    const isMobile = useIsMobile();

    return isMobile ? <MobileFooter /> : <DesktopFooter />;
};
